import { ChangeReason } from '../domain';

export type RebuttalAction = 'Disagree' | 'Agree' | null | undefined;
export type AuditRebuttal = {
  action: RebuttalAction;
  reason: ChangeReason;
  generalComments?: string;
  history?: AuditRebuttal[];
};

export function getRebuttalAction(activity: string): RebuttalAction {
  if (activity === 'REBUTTAL') {
    return 'Disagree';
  }

  if (activity === 'REBUTTALRESPONSE') {
    return 'Agree';
  }
  return undefined;
}
